<template>
    <div class="product-count-item" :class="getBadgeClass">
        <!-- Content -->
        <div class="product-count-content">
            <div class="count-display">
                <div class="count-number">{{ productsCount }}</div>
                <div class="count-label">Artikel</div>
            </div>
            <div v-if="statusLabel" class="status-label">
                {{ statusLabel }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProductCountItem',
    props: {
        productsCount: {
            type: Number,
            required: true
        },
        hasMissingItems: {
            type: Boolean,
            default: false
        },
        isMulticart: {
            type: Boolean,
            default: false
        },
        isWarranty: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        getBadgeClass() {
            // Priority order: warranty (orange) > missing items (red) > multicart (purple) > normal (green)
            if (this.isWarranty) {
                return 'badge-warning';
            } else if (this.hasMissingItems) {
                return 'badge-missing';
            } else if (this.isMulticart) {
                return 'badge-multicart';
            } else {
                return 'badge-normal';
            }
        },
        
        statusLabel() {
            if (this.isWarranty) {
                return 'Reklamation';
            } else if (this.hasMissingItems) {
                return 'Fehlende Artikel';
            } else if (this.isMulticart) {
                return 'Multicart';
            }
            return null;
        }
    }
}
</script>

<style scoped>
.product-count-item {
    position: relative;
    border: 2px solid #e0e0e0;
    border-radius: 8px;
    padding: 10px 12px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
    overflow: hidden;
    min-height: 50px;
}

.product-count-item:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

/* Badge states */
.product-count-item.badge-normal {
    border-color: #4caf50;
    background: linear-gradient(135deg, rgba(76, 175, 80, 0.1), rgba(255, 255, 255, 0.95));
}

.product-count-item.badge-warning {
    border-color: #ff9800;
    background: linear-gradient(135deg, rgba(255, 152, 0, 0.1), rgba(255, 255, 255, 0.95));
    animation: warningPulse 2s ease-in-out infinite;
}

.product-count-item.badge-missing {
    border-color: #f44336;
    background: linear-gradient(135deg, rgba(244, 67, 54, 0.1), rgba(255, 255, 255, 0.95));
    animation: missingPulse 2s ease-in-out infinite;
}

.product-count-item.badge-multicart {
    border-color: #9c27b0;
    background: linear-gradient(135deg, rgba(156, 39, 176, 0.1), rgba(255, 255, 255, 0.95));
}

.product-count-content {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
}

.count-display {
    text-align: center;
}

.count-number {
    font-family: 'Monaco', 'Consolas', monospace;
    font-size: 18px;
    font-weight: 700;
    color: #333;
    line-height: 1;
}

.badge-normal .count-number {
    color: #4caf50;
}

.badge-warning .count-number {
    color: #ff9800;
}

.badge-missing .count-number {
    color: #f44336;
}

.badge-multicart .count-number {
    color: #9c27b0;
}

.count-label {
    font-size: 9px;
    color: #666;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-top: 2px;
}

.status-label {
    font-size: 8px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    padding: 2px 6px;
    border-radius: 3px;
    background-color: rgba(0, 0, 0, 0.05);
}

.badge-warning .status-label {
    color: #ff9800;
    background-color: rgba(255, 152, 0, 0.1);
}

.badge-missing .status-label {
    color: #f44336;
    background-color: rgba(244, 67, 54, 0.1);
}

.badge-multicart .status-label {
    color: #9c27b0;
    background-color: rgba(156, 39, 176, 0.1);
}

/* Animations */
@keyframes warningPulse {
    0%, 100% { border-color: #ff9800; }
    50% { border-color: #ffb74d; }
}

@keyframes missingPulse {
    0%, 100% { border-color: #f44336; }
    50% { border-color: #e57373; }
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .product-count-item {
        padding: 8px 10px;
        min-height: 45px;
    }
    
    .count-number {
        font-size: 16px;
    }
    
    .count-label {
        font-size: 8px;
    }
}
</style>


